import { memo, useState, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import AddIcon from '@mui/icons-material/AddRounded';
import _map from 'lodash/map';
// Local files
import { Root, StyledList } from './List.styled';
import Item from './Item/Item';
import InvitationDialog from 'components/Dialogs/Invitation/Invitation';
import ListSkeleton from 'components/Common/Feedback/ListSkeleton/ListSkeleton';
import Search from 'components/Common/Search/Search';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useCustomSelector from 'hooks/useCustomSelector';
import useManagers from 'hooks/useManagers';
import { managersSelectors } from 'features/managers'

const ManagersList = () => {
  const navigate = useNavigate();
  const { getManagers, clearLocalManagers, clearLocalActiveManager } = useManagers();
  const { data, pagination } = useCustomSelector(managersSelectors.getManagersData)
  const fetching = useCustomSelector(managersSelectors.managersIsFetching)
  const [query, setQuery] = useState('');
  const [invitationDialog, setInvitationDialog] = useState({ open: false });

  const fetchManagers = useCallback((offset, query) => {
    getManagers({ offset, query })
  }, [getManagers]);
  const handleScroll = ({ target: { scrollTop, scrollHeight, offsetHeight } }) => 
  scrollTop >= scrollHeight - offsetHeight && pagination.total_count > pagination.count + pagination.offset && !fetching && fetchManagers(pagination.limit + pagination.offset, query);
  const handleCloseActiveManager = (e) => { 
    e.stopPropagation();
    clearLocalActiveManager()
    navigate('/users');
  };
  const handleClose = () => setInvitationDialog({ open: false });
  
  useEffect(() => {
    const timeout = setTimeout(() => {
      clearLocalManagers();
      fetchManagers(0, query)
    }, !!query ? 500 : 0);

    return () => {
      clearTimeout(timeout);
    }
  }, [query, fetchManagers, clearLocalManagers]);
  useEffect(() => {
    return clearLocalManagers
  }, [clearLocalManagers]);

  return (
    <Root onClick={handleCloseActiveManager}>
      <InvitationDialog 
        {...invitationDialog}
        onClose={handleClose}
      />
      <Box sx={{ display: 'flex', gap: '2px', alignItems: 'center', p: '12px 16px 8px' }}>
        <Search fullWidth value={query} onChange={setQuery} />
        <Button
          variant='contained'
          color='primary'
          sx={{ minWidth: 'unset', height: 30, width: 30, p: .5, borderRadius: '50%' }}
          onClick={() => setInvitationDialog({ open: true })}
        >
         <AddIcon />
        </Button>
      </Box>
      <StyledList onScroll={handleScroll}>
        {_map(data, (m) => <Item key={m.id} {...m} />)}
        {fetching && <ListSkeleton />}
      </StyledList>
    </Root>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <ManagersList {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);